import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportRecipient } from '@app/interfaces/lm/report-schedules';
import { STColumn } from '@app/interfaces/sys/st';
import { ReportSchedulesService } from '@services/lm/report-schedules.service';
import { ReportingService } from '@services/lm/reporting.service';

@Component({
    selector: 'app-recipients-table',
    templateUrl: './recipients-table.component.html',
    styleUrls: ['./recipients-table.component.less'],
})
export class RecipientsTableComponent implements OnInit, OnChanges {
    @Input() currentUser!: ReportRecipient;
    @Input() type = 'project-group';
    @Input() editData: string[] = [];
    @Input() id!: string;
    @Input() showLoading = false;
    columns: STColumn[] = [
        {
            type: 'selection',
            width: '50px'
        },
        {
            title: 'Name',
            index: 'name',
            width: '120px',
            format: (item) => {
                return (item.name ? item.name : '') + ' ' + (item.lastName ? item.lastName : '');
            },
        },
        {
            title: 'Email',
            index: 'email',
            width: '120px'
        },
    ];
    recipientList!: ReportRecipient[];
    loading = false;
    validateForm!: FormGroup;
    listOfControl: any[] = [];
    selectUserEmails: string[] = [];
    autoTips: Record<string, Record<string, string>> = {
        default: {
            required: 'Input is required',
            email: 'The input is not valid email',
        },
    };

    constructor(private reportSchedulesService: ReportSchedulesService,
                private fb: FormBuilder,
                private reportingService: ReportingService) {
    }

    async ngOnInit(): Promise<void> {
        try {
            this.listOfControl = [];
            this.recipientList = [];
            this.selectUserEmails = [this.currentUser.email];
            this.validateForm = this.fb.group({});
            if (!this.id) {
                return ;
            }
            this.loading = true;
            await this.getCandidateList();
            await this.fetchData(this.editData);
        } finally {
            this.loading = false;
        }
    }

    async getCandidateList(): Promise<void> {
        const userList = this.type === 'project' ? await this.reportingService.getProjectReportRecipients({ projectId: this.id }) :
            await this.reportingService.getProjectGroupRecipients({ projectGroupId: this.id });
        const filterUser = userList?.filter((item) => item.id.toString() !== this.currentUser.id.toString());
        this.recipientList = [
            {
                ...this.currentUser,
                id: this.currentUser.id.toString(),
                disabled: true
            },
            ...filterUser
        ];
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        const { editData } = changes;
        if (editData) {
            this.fetchData(this.editData);
        }
    }

    fetchData(allArr: string[]): void {
        if (allArr.length > 1 && this.recipientList && this.recipientList.length > 1) {
            const emails = this.recipientList.map(item => item.email);
            const tableArr = allArr.filter((email: string) => emails.includes(email));
            const formArr = allArr.filter((email: string) => !emails.includes(email));
            this.selectUserEmails = tableArr;
            const fields: { [key: string]: string } = {};
            formArr?.forEach((item, index) => {
                const control: {
                    [key: string]: string | number
                } = {
                    index: index + 1,
                    email: `email${index + 1}`,
                };
                fields[control.email] = item;
                this.addControl(control);
            });
            this.validateForm.reset({
                ...fields,
            });
        } else {
            this.selectUserEmails = allArr;
        }
    }

    addField(e?: MouseEvent): void {
        if (e) {
            e.preventDefault();
        }
        const index = this.listOfControl.length > 0 ? this.listOfControl[this.listOfControl.length - 1].index + 1 : 1;

        const control = {
            index,
            email: `email${index}`
        };
        this.addControl(control);
    }

    addControl(control: { [key: string]: string | number }): void {
        const index = this.listOfControl.push(control);
        const needControl = JSON.parse(JSON.stringify(control));
        delete needControl.index;
        if (needControl.id) {
            delete needControl.id;
        }
        Object.keys(needControl).forEach((item) => {
            this.validateForm.addControl(
                this.listOfControl[index - 1][item],
                new FormControl(null, [Validators.required, Validators.email]),
            );
        });
    }

    handleSelect(ids: string[]): void {
        this.selectUserEmails = [...ids];
    }

    removeField(i: { index: number; email: string; }, e: MouseEvent): void {
        e.preventDefault();
        const index = this.listOfControl.indexOf(i);
        this.listOfControl.splice(index, 1);
        Object.values(i).forEach((fieldItem) => {
            this.validateForm.removeControl(fieldItem as string);
        });
    }

    validForm(): boolean {
        for (const control of Object.values(this.validateForm.controls)) {
            control.markAsDirty();
            control.updateValueAndValidity();
        }
        if (!this.validateForm.valid) {
            return false;
        }
        return true;
    }

    getParams(): string[] {
        const data = this.validateForm.value;
        const arr = this.listOfControl?.map((item) => {
            return data[item.email];
        });
        const recipients = [...new Set([...arr, ...this.selectUserEmails])];
        console.log('recipients', recipients, data, this.selectUserEmails);
        return recipients;
    }

}
